module.exports = __webpack_public_path__ + "img/panier.de66547a.svg";